import React from "react";
import { Platform, Text } from "react-native";

// import styles from "../config/config";
import config from "../config/config";

function AppText({ children, style, numberOfLines = 3, selectable = false, ...otherProps }) {
    return (
        <Text
            style={[config.text, style]}
            numberOfLines={numberOfLines}
            maxFontSizeMultiplier={1.05}
            selectable={selectable}
            allowFontScaling={false}
            ellipsizeMode={"clip"}
            {...otherProps}
        >
            {children}
        </Text>
    );
}

export default AppText;
